// extracted by mini-css-extract-plugin
export default {"card":"A4-z"};